<template>
  <div class="block">
    <el-tag>查看目前账户: </el-tag>
    <el-select v-model="values" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.id"
        :value="item.name"
      >
      </el-option>
    </el-select>
    <el-button type="primary" v-on:click="getDataList"  round>查询</el-button>
    <br>
    <div class="block">
      <el-tag>选 择 日 期: </el-tag>
      <el-date-picker
        v-model="startTime"
        align="right"
        type="date"
        placeholder="选择日期"
        format="yyyyMMdd"
        value-format="yyyyMMdd"
      >
      </el-date-picker>

      <el-button type="primary" v-on:click="exportExcel" round>导出</el-button>
      <el-button type="info" @click="dialog = true" round>添加广告主</el-button>

    </div>
    <el-drawer
      title="添加广告组"

      :visible.sync="dialog"
      direction="ltr"
      custom-class="demo-drawer"
      ref="drawer"

    >
      <div class="demo-drawer__content">
        <el-form position="right" label-width="80px" :model="form">
          <el-form-item label="广告主名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="广告账户ID">
            <el-input v-model="form.advertiseid"></el-input>
          </el-form-item>
          <el-form-item label="APIID">
            <el-input v-model="form.apiId"></el-input>
          </el-form-item>
          <el-form-item label="API密钥">
            <el-input v-model="form.apiKey"></el-input>
          </el-form-item>
          <el-form-item label="tid">
            <el-input v-model="form.tid"></el-input>
          </el-form-item>
          <el-form-item label="名称">
            <el-input v-model="form.oname"></el-input>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="adduser(form)" :loading="loading">添加</el-button>
        </div>
      </div>
    </el-drawer>


    <br>
    <el-divider content-position="center"></el-divider>

    <el-table
      v-loading="loading"
      element-loading-text="拼命查询中..."
      stripe
      :default-sort = "{prop: 'date', order: 'descending'}"
      :data="list"
      id="exportTab"
      show-summary
      :summary-method="getSummaries"
      style="width: 100%">
      <el-table-column
        sortable
        prop="ownerName"
        label="广告主名称"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        prop="ownerId"
        label="广告主ID"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        prop="expose"
        label="曝光量"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        prop="click"
        label="点击量"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        prop="clickRate"
        label="点击率"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        prop="cost"
        label="消耗金额"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        prop="ecpm"
        label="ecpm"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        prop="clickPrice"
        label="点击成本"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        prop="formCnt"
        label="表单提交量"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        prop="formPriceRate"
        label="表单转化率"
        width="180">
      </el-table-column>

      <el-table-column
        sortable
        prop="formPrice"
        label="表单提交成本"
        width="180">
      </el-table-column>

    </el-table>

  </div>

</template>

<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
import {excel} from "../until/excel";


export default {


  data() {
    return {
      handleClose:false,
      dialog:false,
      values:"",
      options:[],
      list:[],
      loading:false,
      startTime:"",
      formLabelWidth: '60px',
      form:{
        apiId:'',
        apiKey:'',
        name:'',
        advertiseid:'',
        tid:'',
        oname:''
      }
    }
  },

  methods: {
    rule(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]).toFixed(2)
        return percent
      }
    },
    cancelForm(){
      this.dialog=false;
    },

    async adduser(form){
      console.log(form)
      await this.$axios.post('http://127.0.0.1/api/addUser1',
        {
          apiid:form.apiId,
          apikey:form.apiKey,
          name:form.name,
          advertiseid:form.advertiseid,
          tid:form.tid,
          oname:form.oname
        }).then(async res=>{
        if(res.data==="添加失败"){
          this.$notify({
            title: "添加失败",
            message: res.data,
            type: 'error'
          });
          this.dialog=false;
        }else{
          this.$notify({
            title: "添加成功",
            message: "广告主已经添加成功",
            type: 'success'
          });
          this.dialog=false;
          this.findUserList();

        }
      })
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总汇';
          return;
        }

        if (index === 1) {

          return;

        }
        if (index === 4) {
          sums[index] = sums[index-1]/sums[index-2];
          sums[index]=sums[index].toFixed(3);
          sums[index]=sums[index]*100+'%'

          return;

        }

        if (index === 6) {
          sums[index] = sums[index-1]/sums[index-4];
          sums[index]= sums[index]*1000
          sums[index]=sums[index].toFixed(2);
          sums[index]=sums[index]
          return;

        }
        if (index === 7) {
          sums[index] = sums[index-2]/sums[index-4];
          sums[index]=sums[index].toFixed(2);
          sums[index]=sums[index]
          return;

        }
        if (index === 9) {
          sums[index] = sums[index-1]/sums[index-6];
          sums[index]= sums[index]*100
          sums[index]=sums[index].toFixed(2);
          sums[index]=sums[index]+'%'


          return;

        }
        if (index === 10) {
          sums[index] = sums[index-5]/sums[index-2];
          sums[index]=sums[index].toFixed(4);
          sums[index]=sums[index]
          return;

        }




        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value)) ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          sums[index] = sums[index].toFixed(2)+ "";
        } else {
          sums[index] = '';
        }
      });
      return sums;

    },
    exportExcel () {
      /* generate workbook object from table */
      var xlsxParam = { raw: false } // 导出的内容只做解析，不进行格式转换
      var wb = XLSX.utils.table_to_book(document.querySelector('#exportTab'), xlsxParam)

      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '数据导出.xlsx')
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout)
        }
      }
      this.$notify({
        title: '成功',
        message: '导出成功',
        type: 'success'
      });
      return wbout

    },
    getDataList(){
      if (this.startTime===""){
        this.$notify({
          title: '失败',
          message: '请选择日期！',
          type: 'error'
        });
      }else {
        this.loading=true
        this.findUserByName(this.values)
      }


    },
    /*
    查询账号列表
     */
    async findUserList(){
      await this.$axios.get('https://test.nbweiou.cn/api/queryUser1').then(
        async res=>{
          this.options=res.data
        }
      )
    },
    /**
     * 账号名称带后端查询
     */
    async findUserByName(name){
      console.log(this.startTime)
      await this.$axios.get('https://test.nbweiou.cn/api/queryAllUserDataxiaoshuo6/'+this.startTime+'/11/').then(
        async res1=>{

          this.list=res1.data
          console.log(res1.data)
          for (let i=0;i<this.list.length;i++){
            this.list[i].clickRate=this.list[i].clickRate+'%';
            this.list[i].formPriceRate=this.list[i].formPriceRate+'%';

            this.list[i].cost=this.list[i].cost/100;
            this.list[i].clickPrice=this.list[i].clickPrice/100;
            this.list[i].clickPrice=this.list[i].clickPrice.toFixed(2);
            this.list[i].cost=this.list[i].cost.toFixed(2);
            this.list[i].formPrice=this.list[i].formPrice/100;
            this.list[i].formPrice=this.list[i].formPrice.toFixed(2);
          }
          this.loading=false
          this.$notify({
            title: '成功',
            message: '查询成功',
            type: 'success'
          });
        }

      )
    }

  },
  created() {
    this.findUserList();

  }
}

</script>




// WEBPACK FOOTER //
// src/components/fengqi.vue